<template>
  <div class="mt-5">
    <appHeader></appHeader>
    <div class="container-fluid p4p-dashboard">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>
              General Dashboard <a href="/admin/dashboard.pdf" target="_blank"> <font-awesome-icon icon="question-circle" /> </a>
            </h4>
            <hr />
            <dashboard-form />
            <hr />
            <report />
          </div>
        </transition>
      </div>
    </div>
    <appFooter class="footer"></appFooter>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import AdminSidebar from '@/views/admin/AdminSidebar.vue';
import DashboardForm from './DashbordForm.vue';
import Report from './Report.vue';
export default {
  name: 'P4PDashboard',

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    DashboardForm,
    Report,
  },

  data() {
    return {};
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('adminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'dashboardP4p',
        activeMenu: this.activeMenu ? this.activeMenu : 'dashboard',
      });
    },
  },
  created() {
    this.setActiveMenuItem();
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.p4p-dashboard {
  // margin: 70px 0 0 0;
  min-height: 100%;
  margin: -0.5% 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
  .card {
    background-image: url(https://new.incentiveweb.com/img/bg-blue.75d34f7d.svg);
    max-width: 100%;
    border-radius: $border-radius-sm;
    background-position: top center;
    background-repeat: repeat;
    background-size: 90px;
    background-color: #f0f9ff;
    label {
      display: block;
    }
  }
  .fileUploadResultAction {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
}

html,
body {
  height: 100%;
}
</style>
